import dayjs from 'dayjs';

// checks if a given date is more than 30 days ago
export const overExpirationDays = (date: string) => {
  const thirtyDaysAgo = dayjs().subtract(30, 'days');
  return dayjs(date).isBefore(thirtyDaysAgo);
};

const getYearsDiff = (date: string) =>
  dayjs().diff(dayjs(date, 'MM/DD/YYYY'), 'years');

const getYearsDiffYearFirst = (date: string) =>
  dayjs().diff(dayjs(date, 'YYYY/MM/DD'), 'years');

const getYearsDiffDayFirst = (date: string) =>
  dayjs().diff(dayjs(date, 'DD/MM/YYYY'), 'years');

export default { getYearsDiff, getYearsDiffYearFirst, getYearsDiffDayFirst };
